import React from "react";
import HiddenDataTable from "../../../../../../components/HiddenDataTable";
import style from "./style.module.scss";
import ButtonIcon from "../../../../../../components/ButtonIcon/ButtonIcon";
import Filter from "../../../../../../assets/svg/icons/common/Filter";
import Download from "../../../../../../assets/svg/icons/common/Download";
import Table from "../../../../../../components/Table";
import Pagination from "../../../../../../components/Pagination/Pagination";
import Calender from "../../../../../../assets/svg/icons/common/Calender";
import CaretDown from "../../../../../../assets/svg/icons/common/CaretDown";
import useMerchantStore from "../../../../../../stores/merchant";

function Deposit() {
  const expandDetails = useMerchantStore((state) => state.expandDetails);

  const tableColumns = [
    {
      headerName: "Routing",
      field: "routing",
      width: 70,
      allowSort: true,
    },
    {
      headerName: "Process Data",
      field: "process_data",
      width: 70,
      allowSort: true,
    },
    {
      headerName: "account",
      field: "account",
      width: 70,
      allowSort: true,
    },
    {
      headerName: "offset",
      field: "offset",
      width: 70,
      allowSort: true,
    },
    {
      headerName: "TRANS. code",
      field: "trans_code",
      width: 70,
      allowSort: true,
    },
    {
      headerName: "Debit/Credit",
      field: "debit_credit",
      width: 70,
      allowSort: true,
    },
    {
      headerName: "DEP./ACH Date",
      field: "ach_date",
      width: 70,
      allowSort: true,
    },
    {
      headerName: "Deposit",
      field: "deposit",
      width: 70,
      allowSort: true,
    },
  ];

  const data = [
    {
      routing: "181",
      process_data: "Feb 2024",
      account: "44470723",
      offset: "9000123",
      trans_code: "12",
      debit_credit: "12",
      ach_date: "10/10/2024",
      deposit: "10/10/2024",
    },
    {
      routing: "181",
      process_data: "Feb 2024",
      account: "44470723",
      offset: "9000123",
      trans_code: "12",
      debit_credit: "12",
      ach_date: "10/10/2024",
      deposit: "10/10/2024",
    },
    {
      routing: "181",
      process_data: "Feb 2024",
      account: "44470723",
      offset: "9000123",
      trans_code: "12",
      debit_credit: "12",
      ach_date: "10/10/2024",
      deposit: "10/10/2024",
    },
    {
      routing: "181",
      process_data: "Feb 2024",
      account: "44470723",
      offset: "9000123",
      trans_code: "12",
      debit_credit: "12",
      ach_date: "10/10/2024",
      deposit: "10/10/2024",
    },
    {
      routing: "181",
      process_data: "Feb 2024",
      account: "44470723",
      offset: "9000123",
      trans_code: "12",
      debit_credit: "12",
      ach_date: "10/10/2024",
      deposit: "10/10/2024",
    },
    {
      routing: "181",
      process_data: "Feb 2024",
      account: "44470723",
      offset: "9000123",
      trans_code: "12",
      debit_credit: "12",
      ach_date: "10/10/2024",
      deposit: "10/10/2024",
    },
  ];

  return (
    <>
      {!expandDetails && (
        <div className={style.container}>
          <HiddenDataTable />
        </div>
      )}

      {expandDetails && (
        <div className={style.container}>
          <header className={style.header}>
            <div className={style.left}>
              <h5>Deposit/ACH details</h5>
              <ButtonIcon textColor="#254FE2">Expand All</ButtonIcon>
            </div>
            <div className={style.right}>
              <ButtonIcon bgColor={"#EDEDF4"}>
                <Calender />
                <span>01/01/24 - 25/01/24</span>
                <CaretDown />
              </ButtonIcon>
              <ButtonIcon bgColor={"#EDEDF4"}>
                <Filter />
              </ButtonIcon>
              <ButtonIcon bgColor={"#EDEDF4"}>
                <Download />
                <span>Download</span>
              </ButtonIcon>
            </div>
          </header>

          <div className={style.body}>
            <Table columns={tableColumns} data={data} />
          </div>

          <footer className={style.footer}>
            <Pagination />
          </footer>
        </div>
      )}
    </>
  );
}

export default Deposit;
